import {
    inRange as inRangeFn,
    random as randomFn,
    clamp as clampFn
} from "lodash-es";

export namespace number {
    /**
     * 
     * @description 产生一个包括 lower 与 upper 之间的随机数
     * @param lower 下限
     * @param upper 上限
     * @param floating 指定是否返回浮点数
     * @returns 
     */
    export function random(lower: number, upper: number, floating: boolean) {
        return randomFn(lower, upper, floating);
    }


    /**
     * @description 检查 targetNumber 是否在 start 与 end 之间，但不包括 end
     * @param targetNumber 
     * @param start 
     * @param end 
     * @returns 
     */
    export function inRange(targetNumber: number, start: number, end?: number): boolean {
        return inRangeFn(targetNumber, start, end);
    }


    /**
     * @description 返回限制在 lower 和 upper 之间的值。
     * @param targetNumber 
     * @param lower 
     * @param upper 
     * @returns 
     */
    export function clamp(targetNumber: number, lower: number, upper: number): number {
        return clampFn(targetNumber, lower, upper)
    }
}
